// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.new', {
        url: '/new',
        templateUrl: 'main/order/orderdelivery/orderdelivery.tpl.html',
        controller: 'OrderDeliveryController as vm',
        resolve: {
            carrier: function () {
                return {
                    data: {
                        links: [],
                        order: {
                            orderNumber: 0,
                            orderArticles: [],
                            orderType: { orderSystemType: 'undefined' },
                            // orderStatus: { orderSystemStatus: 'Created' },
                            systemStatus: 'Created',
                            statusName: 'system.orderSystemStatus.Created',
                            // status: 'Created',
                            orderNumberExternal: "",
                            company: {},
                            fromLocation: {},
                            supplierReference: "",
                            // Destination is kept in vm.selectedDestination
                            plannedDeliveryDate: new Date(),
                            collection: {},
                            termsOfDelivery: "",
                            ourReference: "",
                            cashRegDiscount: "", // ???
                            user: {},
                            summarizedDeliveredQuantity: 0,
                            summarizedPurchaseCost: 0,
                            summarizedQuantity: 0,
                            summarizedSalesPrice: 0,
                            canApproveOrder:false
                        },
                        deliveryPlanningTemplate: []
                    }
                };
            },
            isModifying: function () { return true; },
            isCopying: function () { return false; },
            closeHeaderOnOpen: function () { return false; }
        },
        params: {
            orderSystemType: null,
            articles: null,
            supplierId: null
        }
    });

    $stateProvider.state('order.copyorder', {
        url: '/copy/{orderId}',
        templateUrl: 'main/order/orderdelivery/orderdelivery.tpl.html',
        controller: 'OrderDeliveryController as vm',
        resolve: {
            carrier: orderResolver,
            isModifying: function () { return true; },
            isCopying: function () { return true; },
            closeHeaderOnOpen: function () { return false; }
        }
    });

    $stateProvider.state('order.modifyorder', {
        url: '/modify/{orderId}',
        templateUrl: 'main/order/orderdelivery/orderdelivery.tpl.html',
        controller: 'OrderDeliveryController as vm',
        resolve: {
            carrier: orderResolver,
            isModifying: function () { return true; },
            isCopying: function () { return false; },
            closeHeaderOnOpen: function () { return true; }
        }
    });

    $stateProvider.state('order.orderdelivery', {
        url: '/deliver/{orderId}',
        templateUrl: 'main/order/orderdelivery/orderdelivery.tpl.html',
        controller: 'OrderDeliveryController as vm',
        resolve: {
            carrier: orderResolver,
            isModifying: function () { return false; },
            isCopying: function () { return false; },
            closeHeaderOnOpen: function () { return true; }
        },
        params: {
            usingScannerNavigation: false
        }
    });
}

// @ngInject
function orderResolver($stateParams, OrdersApiService) {
    return OrdersApiService.getById($stateParams.orderId);
}

// @ngInject
function OrderDeliveryController($state, $stateParams, $scope, $translate, carrier, isModifying, isCopying,
                                ResourcesService, loadSpinnerService, $q,
                                OrdersApiService, ProductsApiService, ToasterService,
                                confirmationDialogService, deliveryConfirmationDialogService, OrderService) {
    var vm = this;

    vm.usingScannerNavigation = $stateParams.usingScannerNavigation;
    vm.inputOrderSystemType = $stateParams.orderSystemType;
    vm.inputSupplierId = $stateParams.supplierId;
    vm.inputArticles = $stateParams.articles;

    //Properties
    vm.isModifying = isModifying;
    vm.isCopying = isCopying;
    vm.order = carrier.data.order;
    vm.links = carrier.data.links;
    vm.copiedOrderId = 0;
    vm.scannedBarcodes = "";
    vm.barcodesSendList = [];
    vm.deliveryDate = new Date();
    vm.currentOrderArticle = {};
    vm.orderArticleSwitchingLocked = false;
    vm.isShowingScanningForm = false;
    vm.showOrderMetadataPanel = isModifying;
    vm.orderChangeCount = 0;
    vm.navigationScannerInput = "";
    vm.visibility = {
        orderHeadInput: !vm.closeHeaderOnOpen,
        orderArticlesAddForm: !vm.isModifying
    };
    vm.articlesOnOrder = [];

    vm.deliveryPlanningTemplate = carrier.data.deliveryPlanningTemplate;
    //Methods
    vm.toggleScanningForm = toggleScanningForm;
    vm.downloadOrderLabels = downloadOrderLabels;
    vm.getOrderPrintout = getOrderPrintout;
    vm.toggleMetadataPanelVisibility = toggleMetadataPanelVisibility;
    vm.viewOrderArticle = viewOrderArticle;
    vm.disableOrderArticleSwitching = disableOrderArticleSwitching;
    vm.enableOrderArticleSwitching = enableOrderArticleSwitching;
    vm.isAllowedtoOutDeliverOrder = isAllowedtoOutDeliverOrder;
    vm.isAllowedToSave = isAllowedToSave;
    vm.isAllowedToUseScanningForm = isAllowedToUseScanningForm;
    vm.saveOrder = saveOrder;
    vm.showApproveButton = showApproveButton;
    vm.approveOrder = approveOrder;
    vm.outDeliverOrder = outDeliverOrder;
    vm.receiveArticles = receiveArticles;
    vm.deliverOrder = deliverOrder;
    vm.receiveOrderArticles = receiveOrderArticles;
    vm.finalizeDelivery = finalizeDelivery;
    vm.returnToState = returnToState;
    vm.canDeliverIn = canDeliverIn;
    vm.canDeliverEntireOrder = canDeliverEntireOrder;
    vm.isAllowedToAddProduct = canAddToOrderDuringEdit();


    activate();

    function activate() {
        vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);

        // Watch order destination
        $scope.$watch(function () { return vm.isModifying; }, function () {
            if (vm.isModifying) {
                if (vm.order.destination && vm.order.destination.resellerPriceList &&
                    vm.order.destination.resellerPriceListId && vm.order.destination.resellerPriceListId !== -1) {
                    //Load reseller price list
                    OrdersApiService.getResellerPriceList(vm.order.destination.resellerPriceListId).then(function (response) {
                        vm.order.destination.resellerPriceList = response;
                    }, function (error) {
                        ToasterService.showError(error.message);
                    });
                }
            }
        });

        //Must make sure order meta data has been loaded before populating order rows from inputArticles
        //In this case, currencyRate must be set before effectivePurchasePrice can be calculated
        $scope.$watch(function () { return vm.order.currencyRate; }, function (newValue, oldValue) {
            if (newValue && !oldValue) {
                if (vm.inputArticles && vm.inputArticles !== null) {
                    addArticlesToOrder();
                }

                vm.articlesOnOrder = [];
                _.forEach(vm.order.orderArticles, function (orderArticle) {
                    vm.articlesOnOrder.push({ id: orderArticle.article.id });
                });
            }
        });

        if (vm.isCopying) {
            resetOrderForCopying();
        }

        _.forEach(vm.order.orderArticles, function(orderArticle){
            fillOutOrderRows(orderArticle);
        });
    }

    function canAddToOrderDuringEdit(){
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        return !hasOrderId || vm.order.systemStatus === "created"
    }

    function addArticlesToOrder() {
        //Get full article information
        var promises = [];
        var results = [];
        loadSpinnerService.start('mainSpinner');
        _.forEach(vm.inputArticles, function (article) {
            var articleFetchPromise = ProductsApiService.getProduct(article.id);
            promises.push(articleFetchPromise);
        });

        $q.all(promises).then(function (responses) {
            _.forEach(responses, function (response) {
                results.push(response);
            });

            //Add articles to order article and order rows
            receiveArticles(results);

            //Add quantityToOrder to order rows
            _.forEach(vm.inputArticles, function (article) {
                var orderArticle = _.find(vm.order.orderArticles, { articleId: article.id });
                if (orderArticle) {
                    _.forEach(article.articleVariants, function (articleVariant) {
                        var orderRow = _.find(orderArticle.orderRows, function (row) {
                            return row.articleVariant.id === articleVariant.id;
                        });
                        if (orderRow && articleVariant.quantityToOrder > 0) {
                            orderRow.quantity = articleVariant.quantityToOrder;
                        }
                    });
                }
            });

            vm.orderChangeCount += 1;
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    function resetOrderForCopying() {
        vm.copiedOrderId = vm.order.id;
        vm.order.id = 0;
        vm.order.orderNumber = 0;
        vm.order.orderNumberExternal = '';
        vm.order.systemStatus = 'created';
        vm.order.statusName = 'system.orderSystemStatus.Created';
        // vm.order.orderStatus = {
        //     id: 1,
        //     orderSystemStatus: "created",
        //     isFinalState: false,
        //     orderStatusName: "Skapad"
        // };

        vm.order.approved = false;
        vm.order.hasBeenPrinted = false;

        if (vm.order.orderType.orderSystemType === 'store' || vm.order.orderType.orderSystemType === 'internal') {
            vm.order.destination = undefined;
        }
        if (vm.order.orderType.orderSystemType === 'return' || vm.order.orderType.orderSystemType === 'internal') {
            vm.order.fromLocation = undefined;
        }
        vm.order.plannedDeliveryDate = new Date();
        vm.order.createdDate = new Date();

        _.forEach(vm.order.orderArticles, function (ordArt) {
            _.forEach(ordArt.orderRows, function (ordRow) {
                ordRow.deliveryRows = [];
                // ordRow.orderStatus = {
                //     id: 1,
                //     orderSystemStatus: "created",
                //     isFinalState: false,
                //     orderStatusName: "Skapad"
                // };
                ordRow.systemStatus = "created";
                ordRow.statusName = "system.orderSystemStatus.Created";
            });

            ordArt.lowestSystemStatusAmongRows = "created";
            ordArt.lowestStatusName = "system.orderSystemStatus.Created";

            // ordArt.lowestStatusAmongRows = {
            //     id: 1,
            //     orderSystemStatus: "created",
            //     isFinalState: false,
            //     orderStatusName: "Skapad"
            // };
        });
    }

    function finalizeDelivery() {
        confirmationDialogService.showDialog($translate.instant("order.confirmFinalizeDeliveryMessage"), 'warning').then(function (result) {
            if (result === true) {
                OrdersApiService.markAsDelivered(vm.order.id).then(function (response) {
                    ToasterService.showSuccess($translate.instant("order.deliveryFinalized"), $translate.instant("common.deliver"));
                    $state.go('order.ordersearch', {
                        orderId: vm.order.id,
                        searchTerm: vm.searchTerm,
                        useScannerNavigation: vm.useScannerNavigation,
                        showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                        orderTypes: vm.orderTypes
                    });
                }, function (error) {
                    console.log(error);
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function returnToState() {
        if (vm.order && vm.order.id && vm.order.id > 0) {
            $state.go('order.ordersearch', {
                orderId: vm.order.id,
                searchTerm: vm.searchTerm,
                useScannerNavigation: vm.useScannerNavigation,
                showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                orderTypes: vm.orderTypes
            });
        } else if (vm.isCopying) {
            $state.go('order.ordersearch', {
                orderId: vm.copiedOrderId,
                searchTerm: vm.searchTerm,
                useScannerNavigation: vm.useScannerNavigation,
                showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                orderTypes: vm.orderTypes
            });
        } else {
            $state.go('order.ordersearch', {
                searchTerm: vm.searchTerm,
                useScannerNavigation: vm.useScannerNavigation,
                showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                orderTypes: vm.orderTypes
            });
        }
    }

    //Transform from string to Date, and make sure date has correct timezone and no time information
    function parseDate(input) {
        if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
        } else {
            return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
        }
    }

    function outDeliverOrder() {
        if ((vm.order.destination !== undefined && vm.order.destination.id !== undefined) &&
            (vm.order.fromLocation !== undefined && vm.order.fromLocation.id !== undefined) &&
            vm.order.destination.id === vm.order.fromLocation.id) {
            ToasterService.showError($translate.instant('order.error.sameLocationAsDestination'), $translate.instant('common.error'));
            return;
        }

        loadSpinnerService.start('mainSpinner');
        OrdersApiService.markAsUndelivered(vm.order.id).then(function (response) {
            $state.go('order.ordersearch', {
                orderId: vm.order.id,
                searchTerm: vm.searchTerm,
                useScannerNavigation: vm.useScannerNavigation,
                showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                orderTypes: vm.orderTypes
            });
        }, function (error) {
            console.log(error);
        }).then(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function isAllowedtoOutDeliverOrder() {
        var isAllowed = vm.order && vm.order.id &&
            OrderService.canShipOrder(vm.links);
        return isAllowed;
    }

    function canDeliverIn() {
        return OrderService.canPartDeliverOrder(vm.links);
    }

    function canDeliverEntireOrder() {
        // var isOrderStatusOtherThanDelivered = !vm.order.orderStatus || vm.order.orderStatus.orderSystemStatus !== 'delivered';
        var isOrderStatusOtherThanDelivered = vm.order.systemStatus.toLowerCase() !== 'delivered';
        var canDeliverOrder = OrderService.canDeliverOrder(vm.links);
        return canDeliverOrder && isOrderStatusOtherThanDelivered;
    }

    function disableOrderArticleSwitching() {
        vm.orderArticleSwitchingLocked = true;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function enableOrderArticleSwitching() {
        vm.orderArticleSwitchingLocked = false;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    Date.prototype.addDays = function(days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    };
    Date.prototype.getDatum = function() {
        var dat = new Date(this.valueOf());
        var month = dat.getMonth() + 1;
        if (month < 10) { month = '0' + month; }
        var date = dat.getDate();
        if (date < 10) { date = '0' + date; }
        var str = dat.getFullYear() + '-' + month + '-' + date;
        return str;
    };

    function deliverOrder() {
        var deliver = function(){
            var deliveryDate = new Date();
            var earliestAllowedDeliveryDate = vm.order.earliestAllowedDeliveryDate ?
                new Date(vm.order.earliestAllowedDeliveryDate).getDatum() :
                new Date(vm.order.plannedDeliveryDate.addDays(-30)).getDatum(); //Needs fetch the most recent date from stock table, LastInventoriedDate
            deliveryConfirmationDialogService.showDialog(
                    $translate.instant("order.confirmDeliverWholeOrder"),
                    deliveryDate,
                    earliestAllowedDeliveryDate
                ).then(function (result) {
                if (result.isCompleted === true) {
                    loadSpinnerService.start('mainSpinner');
                    OrdersApiService.deliverOrderWithDate(vm.order.id, result.deliveryDate).then(function(response) {
                            ToasterService.showSuccess($translate.instant("order.delivered"), $translate.instant("common.deliver"));
                            $state.go('order.ordersearch', {
                                orderId: vm.order.id,
                                searchTerm: vm.searchTerm,
                                useScannerNavigation: vm.useScannerNavigation,
                                showOnlyUndeliveredOrders: vm.showOnlyUndeliveredOrders,
                                orderTypes: vm.orderTypes
                            });
                        },
                        function(error) {
                            handleError(error);
                        }
                    ).finally(function () {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
        }

        if(anyRowsWithPurchaseCostLargerThanSalesPrice()){
            confirmationDialogService.showDialog($translate.instant("order.purchasecostIsLargerMessage"), 'danger').then(function (result) {
                if (result === true) {
                    deliver();
                }
            });
        }
        else {
            deliver();
        }
    }

    function anyRowsWithPurchaseCostLargerThanSalesPrice(){
        return vm.order.orderArticles.some(function(orderArticle){
            return orderArticle.orderRows.some(function(orderRow){
                return orderRow.systemStatus !== 'delivered' && 
                    orderRow.systemStatus !== 'voided' &&
                    orderRow.purchaseCost > orderRow.articleVariant.salesPrice
            });
        })
    }

    function toggleScanningForm() {
        if (!vm.isShowingScanningForm) {
            vm.isShowingScanningForm = true;
        } else {
            vm.isShowingScanningForm = false;
            vm.scannedBarcodes = "";
        }
    }

    function resetOrderArticleFlags() {
        _.forEach(vm.order.orderArticles, function (orderArticle) {
            orderArticle['shouldDeliverThisArticle'] = false;

            _.forEach(orderArticle.orderRows, function (orderRow) {
                orderRow['hasBeenModifiedSinceLoad'] = false;
            });
        });
    }

    function viewOrderArticle(article) {
        var orderArticle = _.find(vm.order.orderArticles, function (orderArticle) {
            return orderArticle.article.id === article.id;
        });

        fillOutOrderRows(orderArticle);

        vm.currentOrderArticle = orderArticle;
        vm.showOrderMetadataPanel = vm.isCopying ? true : false;
    }

    function createOrderRows(articleVariants, orderArticle, stocks) {
        return OrderService.createOrderRowsFromArticleVariants(vm.order, articleVariants, orderArticle, stocks);
    }

    function getVariant(variantDetails1Name, variantDetails2Name) {
        var orderRowArticleVariantIds = [];

        _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
            orderRowArticleVariantIds.push(orderRow.articleVariant.id);
        });

        var orderRows = [];
        _.forEach(vm.order.orderArticles, function (orderArticle) {
            _.forEach(orderArticle.orderRows, function (orderRow) {
                if (_.find(orderRowArticleVariantIds, function (articleVariantId) { return articleVariantId === orderRow.articleVariant.id; })) {
                    orderRows.push(orderRow);
                }
            });
        });

        var row = _.find(orderRows, {
            articleVariant: {
                variantDetail1: { variantDetailName: variantDetails1Name },
                variantDetail2: { variantDetailName: variantDetails2Name }
            }
        });

        return row;
    }

    function saveOrder() {
        // Prepare the list of barcodes.
        vm.barcodesSendList = [];
        _.forEach(vm.scannedBarcodes.split('\n'), function (barcode) {
            vm.barcodesSendList.push(barcode.trim());
        });

        //Strip unnecessary data
        var orderToSave = angular.copy(vm.order);
        if (orderToSave.destination && orderToSave.destination.id > 0) {
            orderToSave.destination = { id: orderToSave.destination.id };
        }
        if (orderToSave.fromLocation && orderToSave.fromLocation.id > 0) {
            orderToSave.fromLocation = { id: orderToSave.fromLocation.id };
        }
        _.forEach(orderToSave.orderArticles, function (orderArticle) {
            orderArticle.article = { id: orderArticle.article.id };
            _.forEach(orderArticle.orderRows, function (orderRow) {
                orderRow.articleVariant = {
                    id: orderRow.articleVariant.id,
                    article: { id: orderRow.articleVariant.article.id }
                };
                if (orderRow.destination) { orderRow.destination = { id: orderRow.destination.id }; }
                _.forEach(orderRow.deliveryRows, function (deliveryRow) {
                    deliveryRow.articleVariant = {
                        id: deliveryRow.articleVariant.id,
                        article: { id: deliveryRow.articleVariant.article.id }
                    };
                    deliveryRow.location = { id: deliveryRow.location.id };
                });
            });
        });

        // TODO: Fix the source of the problem instad of using this quick fix.
        // This should be fixed by wrinting a new API method that only returns a very bare bones list of locations, instead of the full location information.
        // Testing removing som superflous data.
        if (vm.isModifying && (orderToSave.id === undefined || orderToSave.id === 0)) {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.createWholeOrder(orderToSave, vm.barcodesSendList, vm.deliveryPlanningTemplate).then(function (response) {
                var responseData = response.data;
                _.forEach(responseData.orderArticles, function (orderArticle) {
                    fillOutOrderRows(orderArticle);
                });
                setOrder(responseData);
                vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);
                vm.scannedBarcodes = "";
                if (vm.isShowingScanningForm) {
                    toggleScanningForm();
                }

                vm.orderChangeCount += 1;

                $state.go('order.modifyorder', { orderId: vm.order.id });
            }, function (error) {
                console.log(error);
                ToasterService.showError(error.message, $translate.instant('common.error'));
            }).finally(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        } else {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.updateWholeOrder(orderToSave).then(function (response) {
                var responseData = response.data;
                _.forEach(responseData.orderArticles, function (orderArticle) {
                    fillOutOrderRows(orderArticle);
                });
                setOrder(responseData);
                vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);
                vm.scannedBarcodes = "";
                if (vm.isShowingScanningForm) {
                    toggleScanningForm();
                }
                vm.orderChangeCount += 1;
            }, function (error) {
                console.log(error);
                ToasterService.showError(error.message, $translate.instant('common.error'));
            }).finally(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function setOrder(orderToSet) {
        // check current state
        var currentArticleId;
        if (vm.currentOrderArticle && vm.currentOrderArticle.article) {
            currentArticleId = vm.currentOrderArticle.article.id;
        }

        vm.order = orderToSet;

        if (currentArticleId) {
            vm.currentOrderArticle = _.find(vm.order.orderArticles, function (orderArticle) {
                return currentArticleId === orderArticle.article.id;
            });
        }
    }

    function showApproveButton() {
        if (vm.order.canApproveOrder === true) {
            var orderIsSaved = vm.order.id !== undefined && vm.order.id > 0;

            return orderIsSaved && OrderService.canApproveOrder(vm.links);
        }
        return false;
    }

    function approveOrder() {
        if (!vm.order.approved && vm.isModifying && vm.order.id && vm.order.id > 0) {
            //Confirm approve order
            var approveMessage = $translate.instant('order.confirmApproveOrder').replace(/%1/g, '<br>');
            confirmationDialogService.showDialog(approveMessage).then(function (result) {
                if (result === false) {
                    return;
                }

                loadSpinnerService.start('mainSpinner');
                OrdersApiService.approveOrder(vm.order.id).then(function (response) {
                    ToasterService.showSuccess($translate.instant("order.orderApproved"), $translate.instant("common.order"));
                    vm.order.approved = true;
                    vm.orderChangeCount += 1;
                }, function (error) {
                    console.log(error);
                    ToasterService.showError($translate.instant("order.unableApproveOrder"), $translate.instant("common.error"));
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            });
        }
    }

    function isAllowedToSave() {
        var hasOrderType = vm.order.orderType !== undefined && vm.order.orderType.id !== undefined;
        var hasCurrency = vm.order.currency !== undefined && vm.order.currency.id !== undefined;
        var hasDestination = vm.order.destination !== undefined && vm.order.destination.id !== undefined;
        var hasFromLocation = vm.order.fromLocation !== undefined && vm.order.fromLocation.id !== undefined;
        var hasCompany = vm.order.company !== undefined && vm.order.company.id !== undefined;
        var hasCurrencyRate = vm.order.currencyRate !== undefined && vm.order.currencyRate !== "";

        if (hasOrderType && hasCurrency && hasCurrencyRate) {
            if (vm.order.orderType.orderSystemType.toLowerCase() === 'store' && hasCompany && hasDestination) {
                return true;
            } else if (vm.order.orderType.orderSystemType.toLowerCase() === 'internal' && hasFromLocation && hasDestination) {
                return true;
            } else if (vm.order.orderType.orderSystemType.toLowerCase() === 'return' && hasCompany && hasFromLocation) {
                return true;
            } else if (vm.order.orderType.orderSystemType.toLowerCase() === 'automatic' && hasCompany && hasDestination) {
                return true;
            } else if (vm.order.orderType.orderSystemType.toLowerCase() === 'automaticinternal' && hasFromLocation && hasDestination) {
                return true;
            }
        }

        return false;
    }

    function isAllowedToUseScanningForm() {
        if (vm.order.orderArticles.length > 0) {
            return false;
        }
        return true;
    }

    function receiveArticles(articles) {
        for (var i = 0; i < articles.length; i++) {
            var fakedOrderArticle = {
                id: 0,
                orderLineNumber: 0,
                orderId: 0,
                articleId: articles[i].id,
                article: articles[i],
                summarizedQuantity: 0,
                summarizedDeliveredQuantity: 0,
                summarizedPurchaseCost: 0,
                summarizedSalesPrice: 0,

                // lowestStatusAmongRows: {
                //     orderSystemStatus: 'Created'
                // },
                lowestStatusName: 'system.OrderRowSystemStatus.Created',
                LowestSystemStatusAmongRows: 'Created',
                orderRows: []
            };

            vm.order.orderArticles.push(fakedOrderArticle);

            fillOutOrderRows(fakedOrderArticle);
        }

        vm.articlesOnOrder = [];
        _.forEach(vm.order.orderArticles, function (orderArticle) {
            vm.articlesOnOrder.push({ id: orderArticle.article.id });
        });

        vm.orderChangeCount += 1;
    }

    function fillOutOrderRows(orderArticle) {
        var missingArticleVariants = [];
        _.forEach(orderArticle.article.articleVariants, function (artVar) {
            if (!_.find(orderArticle.orderRows, function (orderRow) { return orderRow.articleVariant.id === artVar.id; })) {
                missingArticleVariants.push(artVar);
            }
        });

        var locationIds = [];
        if (vm.order.fromLocation !== undefined && vm.order.fromLocation !== undefined && vm.order.fromLocation.id !== undefined && vm.order.fromLocation.id !== 0) {
            locationIds.push(vm.order.fromLocation.id);
        }
        var articleVariantIds = [];
        _.forEach(missingArticleVariants, function (av) { articleVariantIds.push(av.id); });

        if (vm.order.orderType.orderSystemType.toLowerCase() === 'internal') {
            loadSpinnerService.start('main-spinner');
            OrdersApiService.getStocksForArticleVariants(articleVariantIds, locationIds).then(function (response) {
                var stocks = response.data;

                var missingOrderRows = createOrderRows(missingArticleVariants, orderArticle, stocks);

                // don't show non-order rows for delivery form since we are not able to
                // handle them in the back end.
                if (vm.isModifying) {
                    _.forEach(missingOrderRows, function (orderRow) {
                        orderArticle.orderRows.push(orderRow);
                    });
                }

            }, function (error) {
                ToasterService.showError(error.message, $translate.instant('common.error'));
            }).finally(function () {
                loadSpinnerService.stop('main-spinner');
            });
        } else {
            var missingOrderRows = createOrderRows(missingArticleVariants, orderArticle);

            if (orderArticle && orderArticle.orderRows.length > 0) {
                var orderRow = orderArticle.orderRows[0];
                _.forEach(missingOrderRows, function(missingOrderRow) {
                    missingOrderRow.discountPercent = orderRow.discountPercent;
                    missingOrderRow.standardCostAddPercent = orderRow.standardCostAddPercent;
                    missingOrderRow.shippingCost = orderRow.shippingCost;
                    missingOrderRow.customsPercent = orderRow.customsPercent;
                    missingOrderRow.otherCosts = orderRow.otherCosts;
                });
            }

            if (vm.isModifying) {
                _.forEach(missingOrderRows, function (orderRow) {
                    orderArticle.orderRows.push(orderRow);
                });
            }
        }

    }

    function downloadOrderLabels() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadLabels(vm.order.id, vm.order.orderNumber).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getOrderPrintout() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadAsPdf(vm.order.id).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

    function toggleMetadataPanelVisibility() {
        vm.showOrderMetadataPanel = !vm.showOrderMetadataPanel;
    }

    function receiveOrderArticles(orderArticles) {
        var fakedOrderArticles = orderArticles;

        _.forEach(fakedOrderArticles, function (oa) {
            _.forEach(oa.orderRows, function (or) {
                or.destination = vm.order.destination;
            });
        });

        _.forEach(fakedOrderArticles, function (fakedOrderArticle) {
            var preExistingOrderArticle = _.find(vm.order.orderArticles, function (oa) { return oa.articleId === fakedOrderArticle.articleId; });
            if (preExistingOrderArticle !== undefined) {
                _.forEach(fakedOrderArticle.orderRows, function (fakedOrderRow) {
                    var preExistingOrderRow = _.find(preExistingOrderArticle.orderRows, function (or) { return or.articleVariant.id === fakedOrderRow.articleVariant.id; });
                    if (preExistingOrderRow !== undefined) {
                        preExistingOrderRow.quantity += fakedOrderRow.quantity;
                    } else {
                        preExistingOrderArticle.orderRows.push(fakedOrderRow);
                    }
                });
            } else {
                vm.order.orderArticles.push(fakedOrderArticle);
            }
        });

        vm.currentOrderArticle = undefined;
        vm.orderChangeCount += 1;
    }
}

angular
    .module('order.orderdelivery', [])
    .config(stateConfig)
    .controller('OrderDeliveryController', OrderDeliveryController);
